import React from 'react';
import { useTranslation } from "@/lib/i18n";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Keyboard } from 'lucide-react';

export default function KeyboardShortcutsModal({ open, onOpenChange }) {
  const { t } = useTranslation('editor');

  const SHORTCUTS = [
    {
      category: t('shortcuts_modal.categories.tools'),
      items: [
        { keys: ['V'], description: t('shortcuts_modal.items.select') },
        { keys: ['R'], description: t('shortcuts_modal.items.rect') },
        { keys: ['C'], description: t('shortcuts_modal.items.circle') },
        { keys: ['P'], description: t('shortcuts_modal.items.pen') },
        { keys: ['T'], description: t('shortcuts_modal.items.text') },
      ],
    },
    {
      category: t('shortcuts_modal.categories.editing'),
      items: [
        { keys: ['Ctrl', 'Z'], description: t('shortcuts_modal.items.undo') },
        { keys: ['Ctrl', 'Shift', 'Z'], description: t('shortcuts_modal.items.redo') },
        { keys: ['Ctrl', 'G'], description: t('shortcuts_modal.items.group') },
        { keys: ['Ctrl', 'Shift', 'G'], description: t('shortcuts_modal.items.ungroup') },
        { keys: ['Del', 'Backspace'], description: t('shortcuts_modal.items.delete') },
      ],
    },
    {
      category: t('shortcuts_modal.categories.navigation'),
      items: [
        { keys: ['F11'], description: t('shortcuts_modal.items.fullscreen') },
        { keys: ['Alt', 'Enter'], description: t('shortcuts_modal.items.alt_fullscreen') },
        { keys: ['Esc'], description: t('shortcuts_modal.items.exit_fullscreen') },
      ],
    },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-zinc-900 border-zinc-800 text-zinc-100">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-zinc-100">
            <Keyboard className="w-5 h-5 text-indigo-400" />
            {t('shortcuts_modal.title')}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          {SHORTCUTS.map((section) => (
            <div key={section.category} className="space-y-2">
              <h4 className="text-xs font-semibold text-zinc-400 uppercase tracking-wider">
                {section.category}
              </h4>
              <div className="bg-zinc-950 border border-zinc-800/80 rounded-lg p-2.5 space-y-2">
                {section.items.map((item) => (
                  <div
                    key={item.description}
                    className="flex items-center justify-between text-xs"
                  >
                    <span className="text-zinc-300">{item.description}</span>
                    <div className="flex items-center gap-1">
                      {item.keys.map((key) => (
                        <kbd
                          key={key}
                          className="px-1.5 py-0.5 text-[10px] font-mono font-semibold bg-zinc-800 text-zinc-300 border border-zinc-700 rounded shadow-sm"
                        >
                          {key}
                        </kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}